import { useEffect, useState } from "react";
import { Menu, X, Github } from "lucide-react";
import { ThemeToggle } from "./ThemeToggle";
import { navLinks, profile } from "../../data/portfolioData";

export const Navbar = () => {
    const [open, setOpen] = useState(false);
    const [scrolled, setScrolled] = useState(false);

    useEffect(() => {
        const onScroll = () => setScrolled(window.scrollY > 8);
        onScroll();
        window.addEventListener("scroll", onScroll);
        return () => window.removeEventListener("scroll", onScroll);
    }, []);

    return (
        <header
            data-testid="site-navbar"
            className={`fixed inset-x-0 top-0 z-50 transition-all duration-300 ${
                scrolled
                    ? "backdrop-blur-xl bg-[var(--ink-bg)]/70 border-b border-[var(--ink-border)]"
                    : "bg-transparent"
            }`}
        >
            <nav className="mx-auto flex max-w-7xl items-center justify-between px-6 py-4 md:px-12 lg:px-16">
                <a
                    href="#top"
                    data-testid="nav-logo-link"
                    className="group flex items-center gap-2 font-mono text-sm tracking-tight text-[var(--ink-text-primary)]"
                >
                    <span className="inline-flex h-7 w-7 items-center justify-center rounded-md border border-[var(--ink-border)] bg-[var(--ink-surface)] text-ink-cyan transition-colors group-hover:border-ink-cyan/50">
                        v
                    </span>
                    <span className="text-[var(--ink-text-secondary)]">~/</span>
                    <span>{profile.handle}</span>
                    <span className="text-ink-cyan">.</span>
                    <span className="text-[var(--ink-text-secondary)]">
                        site
                    </span>
                </a>

                <ul className="hidden items-center gap-8 md:flex">
                    {navLinks.map((l) => (
                        <li key={l.href}>
                            <a
                                href={l.href}
                                data-testid={`nav-link-${l.label.toLowerCase()}`}
                                className="font-mono text-xs uppercase tracking-[0.2em] text-[var(--ink-text-secondary)] transition-colors hover:text-ink-cyan"
                            >
                                {l.label}
                            </a>
                        </li>
                    ))}
                </ul>

                <div className="flex items-center gap-2">
                    <a
                        href={profile.links.github}
                        target="_blank"
                        rel="noreferrer"
                        data-testid="nav-github-link"
                        className="hidden h-9 w-9 items-center justify-center rounded-md border border-[var(--ink-border)] bg-[var(--ink-surface)] text-[var(--ink-text-secondary)] transition-colors hover:border-ink-cyan/40 hover:text-ink-cyan md:inline-flex"
                        aria-label="GitHub"
                    >
                        <Github className="h-4 w-4" />
                    </a>
                    <ThemeToggle />
                    <button
                        type="button"
                        onClick={() => setOpen((v) => !v)}
                        data-testid="nav-mobile-toggle"
                        aria-label="Toggle navigation"
                        className="inline-flex h-9 w-9 items-center justify-center rounded-md border border-[var(--ink-border)] bg-[var(--ink-surface)] text-[var(--ink-text-secondary)] md:hidden"
                    >
                        {open ? (
                            <X className="h-4 w-4" />
                        ) : (
                            <Menu className="h-4 w-4" />
                        )}
                    </button>
                </div>
            </nav>

            {open ? (
                <div
                    data-testid="nav-mobile-menu"
                    className="border-t border-[var(--ink-border)] bg-[var(--ink-bg)] md:hidden"
                >
                    <ul className="mx-auto flex max-w-7xl flex-col gap-1 px-6 py-4">
                        {navLinks.map((l) => (
                            <li key={l.href}>
                                <a
                                    href={l.href}
                                    onClick={() => setOpen(false)}
                                    data-testid={`nav-mobile-link-${l.label.toLowerCase()}`}
                                    className="block rounded-md px-3 py-2 font-mono text-sm text-[var(--ink-text-secondary)] transition-colors hover:bg-[var(--ink-surface)] hover:text-ink-cyan"
                                >
                                    {l.label}
                                </a>
                            </li>
                        ))}
                    </ul>
                </div>
            ) : null}
        </header>
    );
};

export default Navbar;
